import React from 'react';
import ASD from '../../assets/asdIndus.png';
import Auto from '../../assets/auto.png';
import school from '../../assets/space-school.png';
import doc from '../../assets/doc.png';
import crypto from '../../assets/crypto.png';
import dashboard1 from '../../assets/dashboard1.png';

import './portfolio.css';

const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: 'ASD Dashboard',
      para: 'Ive tried to implement all the advance and modern features in this Dashboard app. Some great pages like Ecommerce, Orders, Customers & Employees. Users can see data table in Orders, Customers and Employees pages. Pagination, Data Edit, Update, Data Sorting, Marking-Deleting and more features',
      img: dashboard1,
      link: 'https://asd-dashboard1.web.app/',
      github1: 'https://github.com/asadulR/ASD-Dashboard',
      github2: 'https://asd-dashboard1.web.app/',
    },
    {
      id: 2,
      title: 'ASD Industrial',
      para: 'ASD Industrial is a SPA for a tools manufacturing company. Users can order tools, give a review from their dashboard page, payment, cancel previous order. Firebase auth and firebase hosting. JWT for APIs authorization. Users have to Sign Up for all page access.',
      img: ASD,
      link: 'https://asd-industrial.web.app/',
      github1: 'https://github.com/asadulR/ASD-Industrial-UI',
      github2: 'https://github.com/asadulR/ASD-Industrial-server',
    },
    {
      id: 3,
      title: 'Auto Accord',
      para: 'Auto Accord is a warehouse Inventory management website. An User can update Inventory information. Delete inventory from the database and add a new one. Users can see their previous added inventory at My Inventory page. Users have to Sign Up for all page access.',
      img: Auto,
      link: 'https://auto-accord-10e53.web.app/',
      github1: 'https://github.com/asadulR/Auto-Accord-UI',
      github2: 'https://github.com/asadulR/Auto-Accord-Server',
    },
    {
      id: 4,
      title: 'Doc +',
      para: 'Doc + is Dental Treatment providing web app. Users can see the avaiable appointment on the day.  User can book an Appointment at a time, can see their appoinments in the Dashboard page. React-Router to turn the application into Single Page Application.Sign Up for all page access.',
      img: doc,
      link: 'https://doc-plus-b2108.web.app/',
      github1: 'https://github.com/asadulR/Doc-plus-UI',
      github2: 'https://github.com/asadulR/Doc-plus-Server',
    },
    {
      id: 5,
      title: 'Space School',
      para: 'Space School is a website where we can store students informations. Update any student informations, delete any student record from the database, add new student to the database.',
      img: school,
      link: 'https://space-school-asadul.netlify.app/',
      github1: 'https://github.com/asadulR/Space-School-Record',
      github2: 'https://github.com/asadulR/Space-School-Server',
    },
    {
      id: 6,
      title: 'Crypto Masters Club',
      para: 'Crypto Masters Club is a website where we can see almost 60 crypto coins. We can see all the informations of a coin in a different route if we click on the coin.',
      img: crypto,
      link: 'https://crypto-masters-club.netlify.app/',
      github1: 'https://github.com/asadulR/Crypto-Master-Club',
      github2: 'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=50&page=1&sparkline=false',
    }

  ];


  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <h3>{pro.title}</h3>
            <p>{pro.para}</p>
            <div className="portfolio__item-cta">
              <a href={pro.link} className="btn btn-primary btn-sm" target="_blank" rel="noreferrer">Live Demo</a>
              <a href={pro.github1} className="btn btn-sm" target="_blank" rel="noreferrer">GitHub</a>
              <a href={pro.github2} className="btn btn-sm" target="_blank" rel="noreferrer">Server Code</a>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default Portfolio